import { useState } from "react";
import { BOARDS, type BoardId } from "@numi/engine";
import { api } from "../api.ts";
import { useApp, selectChild, refreshMe, signOut, toast } from "../store.ts";
import { Card, Numi } from "../ui.tsx";
import { SFX } from "../sound.ts";

const COLORS = ["var(--t-orange)", "var(--t-sky)", "var(--t-leaf)", "var(--purple)", "var(--t-pink)", "var(--t-orange)"];
export function ChildForm({ onDone, initial }: { onDone: (id?: string) => void; initial?: { name: string; grade: number; board: BoardId; lang: string } }) {
  const [name, setName] = useState(initial?.name ?? ""); const [grade, setGrade] = useState(initial?.grade ?? 3);
  const [board, setBoard] = useState<BoardId>(initial?.board ?? "cbse"); const [lang, setLang] = useState(initial?.lang ?? "English");
  const [err, setErr] = useState(""); const [busy, setBusy] = useState(false);
  const gw = BOARDS[board].gradeWord;
  const save = async (e: React.FormEvent) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { const r = await api("/children", { body: { name, grade, board, lang } }); await refreshMe(); onDone(r.id); }
    catch (x: any) { setErr(x.message); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={save} className="card" style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <h2 style={{ fontSize: "1.5rem" }}>Add a child</h2>
      <div className="fields">
        <label className="field"><span className="lbl">First name</span><input className="inp" id="cname" required maxLength={30} value={name} onChange={(e) => setName(e.target.value)} /></label>
        <label className="field"><span className="lbl">Board</span><select className="inp" id="cboard" value={board} onChange={(e) => setBoard(e.target.value as BoardId)}>{Object.entries(BOARDS).map(([k, b]) => <option key={k} value={k}>{b.name}</option>)}</select></label>
        <label className="field"><span className="lbl">{gw}</span><select className="inp" id="cgrade" value={grade} onChange={(e) => setGrade(+e.target.value)}>{[1, 2, 3, 4, 5].map((g) => <option key={g} value={g}>{gw} {g} · age {g + 5}–{g + 6}</option>)}</select></label>
        <label className="field"><span className="lbl">Numi explains in</span><select className="inp" id="clang" value={lang} onChange={(e) => setLang(e.target.value)}>{["English", "Hinglish", "Hindi", "Arabic"].map((l) => <option key={l}>{l}</option>)}</select></label>
      </div>
      <p className="note">We only need a first name. Numi never asks children for personal details.</p>
      {err && <p className="err" role="alert">{err}</p>}
      <div className="row"><button className="btn yellow big" disabled={busy}>Save</button><button type="button" className="btn soft" onClick={() => onDone()}>Cancel</button></div>
    </form>
  );
}

export function Kids() {
  const s = useApp(); const [adding, setAdding] = useState(s.children.length === 0);
  const pickChild = async (id: string) => { SFX.tap(); try { await selectChild(id); } catch (e: any) { toast(e.message); } };
  return (
    <main>
      <Card className="hero" style={{ gridTemplateColumns: "auto 1fr" }}><Numi size={96} mood="fly" /><div><h2>Who's learning today?</h2><p>Tap your name to start.</p></div></Card>
      {adding ? <ChildForm onDone={(id) => { setAdding(false); if (id) pickChild(id); }} /> : (
        <div className="kids">
          {s.children.map((c, i) => <button key={c.id} className="kid" style={{ background: COLORS[i % 6], color: "#fff" }} onClick={() => pickChild(c.id)}>
            <Numi size={64} />{c.name}<small style={{ color: "#fff" }}>{BOARDS[c.board]?.gradeWord} {c.grade} · {c.total_stars ?? 0} stars</small></button>)}
          {s.children.length < 6 && <button className="kid add" onClick={() => setAdding(true)}>+ Add a child<small>For brothers and sisters too</small></button>}
        </div>
      )}
      <p className="note" style={{ textAlign: "center" }}>Signed in as {s.parent?.email}. <button className="linkbtn" onClick={signOut}>Sign out</button></p>
    </main>
  );
}
declare module "../store.ts" { interface Child { total_stars?: number } }
